// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramMultifamilyWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingAdvertisingDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingQualityScoreDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
  RentalManagerListingFieldSortType,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  ascending?: boolean;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeFreeBonusListingsOnly?: boolean;
  includeFreeClaimedListingsOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  sort?: RentalManagerListingFieldSortType;
  startKeyExclusive?: string;
}
interface ListingQualityScoreParams {
  listingAlias: ListingAlias;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Options = UseQueryOptions<
  AccountViewListingAdvertisingDto,
  unknown,
  AccountViewListingAdvertisingDto,
  Array<string | AdvertisingParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey = (getParams: AdvertisingParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path,
  getParams,
];

/**
 * Get multifamily customer account view property listing advertising
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_advertising.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  Array<string | ListParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey = (getParams: ListParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path,
  getParams,
];

/**
 * Get multifamily customer account view property list
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_list(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_list.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Options = UseQueryOptions<
  AccountViewListingQualityScoreDto,
  unknown,
  AccountViewListingQualityScoreDto,
  Array<string | ListingQualityScoreParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey = (
  getParams: ListingQualityScoreParams,
) => [RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path, getParams];

/**
 * Get multifamily customer account view property listing quality score
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore = (
  getParams: ListingQualityScoreParams,
  options: Omit<
    RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  Array<string | OptionsParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey = (getParams: OptionsParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path,
  getParams,
];

/**
 * Get multifamily customer account view property listing options
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_options = (
  getParams: OptionsParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_options(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_options.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Options = UseQueryOptions<
  AccountViewListingProspectsDto,
  unknown,
  AccountViewListingProspectsDto,
  Array<string | ProspectsParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey = (getParams: ProspectsParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path,
  getParams,
];

/**
 * Get multifamily customer account view property prospects
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_prospects.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Options = UseQueryOptions<
  AccountViewListingSourcesDto,
  unknown,
  AccountViewListingSourcesDto,
  Array<string | SourcesParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey = (getParams: SourcesParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path,
  getParams,
];

/**
 * Get multifamily customer account view property listing sources
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_sources(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_sources.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Options = UseQueryOptions<
  AccountViewListingStatusOverviewDto,
  unknown,
  AccountViewListingStatusOverviewDto,
  Array<string | StatusParams>
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey = (getParams: StatusParams) => [
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path,
  getParams,
];

/**
 * Get multifamily customer account view property listing status
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_status = (
  getParams: StatusParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_status(getParams),
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_status.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey;
